import React from 'react';
import { useI18n } from '../i18n';
import LegalLayout from './LegalLayout';

export default function Support() {
  const { t } = useI18n();
  const s = t.legal.support;
  return (
    <LegalLayout eyebrow={s.eyebrow} title={s.title}>
      <p>{s.intro}</p>
      <h2>{s.hContact}</h2>
      <ul>
        <li><strong>{s.emailLabel}</strong> <a href="mailto:contact@hitmax.io">contact@hitmax.io</a></li>
        <li>{s.delay}</li>
      </ul>
      <h2>{s.hFaq}</h2>
      <p><strong>{s.q1}</strong><br />{s.a1}</p>
      <p><strong>{s.q2}</strong><br />{s.a2}</p>
      <p><strong>{s.q3}</strong><br />{s.a3}</p>
      <h2>{s.hResp}</h2>
      <p>{s.pResp}</p>
    </LegalLayout>
  );
}
